module.exports = __webpack_public_path__ + "media/images/admin/icons/settings-8588567d7abe6a39f8ce830321ab1234.svg";